// import { saveTiming, saveActionLog, saveExceptionLog } from 'lib/requestLog'
// import { isFunction } from 'lib/detectType'
import getAllProperties from 'lib/getAllProperties'
import ReactGA4 from 'lib/ga4'
import debounce from 'lodash/debounce'

const mapActionLog = (self, options = {}) => {
  getAllProperties(self, options).forEach(methodName => {
    self[methodName] = actionLog(
      self[methodName],
      self.props.componentName,
      methodName
    )
  })
}
const failedLogging = debounce(
  (componentName, methodName, message) => {
    ReactGA4.event('failed_container_method', {
      method_name: [componentName, methodName].join('|'),
      jsErrorMessage: message
    })
  },
  1000,
  { leading: true }
)
const succeededLogging = debounce(
  (componentName, methodName) => {
    ReactGA4.event('succeeded_container_method', {
      method_name: [componentName, methodName].join('|')
    })
  },
  1000,
  { leading: true }
)
const actionLog = (method, componentName, methodName) => {
  return function () {
    let result
    try {
      result = method(...arguments)
      if (process.env.NODE_ENV !== 'development') {
        succeededLogging(componentName, methodName)
      }
      return result
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        throw error
      } else {
        failedLogging(componentName, methodName, error?.message)
      }
    } finally {
    }
  }
}

export default mapActionLog
